import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";

const CustomAccordion = ({ value, toggleMenu, children }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      expanded={expanded}
      sx={{
        width: "100%",
        padding: "0px",
        boxShadow: "none",
        border: "0px solid",
      }}
    >
      <AccordionSummary
        sx={{
          width: "-webkit-fill-available",
          padding: "0px",
          margin: "0px",
          boxShadow: "none",
          border: "0px solid",
          "& .MuiAccordionSummary-root": {
            width: "-webkit-fill-available",
          },
        }}
        expandIcon={
          <ExpandMoreIcon
            onClick={(e) => {
              e.stopPropagation();
              setExpanded((prev) => !prev);
            }}
            style={{ cursor: "pointer" }}
          />
        }
        onClick={() => setExpanded((prev) => !prev)}
        aria-controls="panel1d-content"
        id="panel1d-header"
      >
        <div className="text-[#292929] font-[Roboto] text-[18px] font-normal cursor-pointer w-full">{value}</div>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "0px" }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
